import React, { useState } from "react";
import { verifyPasswordResetCode, confirmPasswordReset } from "firebase/auth";
//import { applyActionCode, getAuth } from "firebase/auth";
import { auth } from "../../firebase";
import PasswordInput from "../Inputs/PasswordInput";
import PrimaryButton from "../Buttons/PrimaryButton";
import "./styles.scss";
import VerificationScreen from "../VerificationScreen/VerificationScreen";
import { isMobile } from "react-device-detect";
//import { useNavigate } from "react-router-dom";
//import { useSearchParams } from 'react-router-dom';


function ActionResetPassword({searchParams}) {
  //const [searchParams] = useSearchParams();
  
  const actionCode = searchParams.get("oobCode");
  // const continueUrl = searchParams.get("continueUrl");
  // const lang = searchParams.get("lang");
  const [newPassword, setNewPassword] = useState("");
  const [showNewPassword, setShowNewPassowrd] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showConfirmPassword, setShowConfirmPassowrd] = useState(false);
  const [error, setError] = useState("");
  const [passwordUpdate, setPasswordUpdate] = useState(false);


 // const auth = getAuth();
  //const navigate = useNavigate();
  const resetPassword = (e) => {
    e.preventDefault();
    if (
      newPassword === confirmPassword &&
      newPassword !== "" &&
      confirmPassword !== ""
    ) {
      setError("");
      verifyPasswordResetCode(auth, actionCode)
        .then((email) => {
          //const accountEmail = email;

          // Save the new password.
          confirmPasswordReset(auth, actionCode, newPassword)
            .then((resp) => {
              //console.log(resp);
              setPasswordUpdate(true);
               const mobileUrl = "https://go.peeq.inc/signIn/";
              // const desktopUrl = "/";

              setTimeout(() => {
                if (isMobile) {
                  window.location.href = mobileUrl;
                } else {
                  window.location.href = 'https://admin.peeq.inc/signin/';
                }
              }, 4000);
            })
            .catch((error) => {
              const cleanedErrorMessage = error.message.replace(
                /^Firebase: /,
                ""
              );
              setError(cleanedErrorMessage);
              console.log(error);
            });
        })
        .catch((error) => {
          const cleanedErrorMessage = error.message.replace(/^Firebase: /, "");
          setError(cleanedErrorMessage);
          console.log(error);
        });
    } else if (newPassword === "" && confirmPassword === "") {
      setError("Password can not be empty");
    } else {
      setError("Passwords do not match");
    }
  };

  return (
    <div className="pw-main flex flex-col w-full justify-center items-center mt-12">
      {passwordUpdate === false ? (
        <div className="flex flex-col gap-20 sm:gap-4 w-[80%] md:w-[50%]">
          <div className="w-max p-12 flex justify-center self-center items-center bg-[#ffae001a] rounded-full">
            <div className="relative h-20 w-20">
              <img src='/key.svg' alt="key-icon" fill />
            </div>
          </div>

          <div>
          <div className="flex flex-col gap-1 self-center md:self-start items-center justify-center md:items-start md:justify-start">
            {" "}
            <h3 className="text-[#2A2F40] text-[1.375rem] md:text-[2rem] font-satoshi-black">
              Create New Password
            </h3>
            <p className="text-[#555966] text-[1rem] font-satoshi leading-normal">
              Enter and confirm your new password
            </p>
          </div>

          <form
            className="flex flex-col gap-4 md:gap-6 mt-4"
            onSubmit={resetPassword}
          >
            <PasswordInput
              required={true}
              text={"Password"}
              value={newPassword}
              name={"new_password"}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder={"Password"}
              onClick={(prevValue) => setShowNewPassowrd(!showNewPassword)}
              showPassword={showNewPassword}
            />
            <PasswordInput
              required={true}
              text={"Confirm Password"}
              value={confirmPassword}
              name={"confirm_password"}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder={"Confirm Password"}
              onClick={() => setShowConfirmPassowrd(!showConfirmPassword)}
              showPassword={showConfirmPassword}
            />

            <div className="text-red-600 ">{error}</div>
            <div className="w-full flex flex-row justify-end items-center">
              <div className="hidden md:block">
                <PrimaryButton text={"Confirm"} type={"submit"} />
              </div>
              <div className="block md:hidden w-full">
                <PrimaryButton
                  text={"Confirm"}
                  type={"submit"}
                  variant="full"
                />
              </div>
            </div>
          </form>
          </div>
        </div>
      ) : (
        <VerificationScreen text={"Password Changed"} />
      )}
    </div>
  );
}

export default ActionResetPassword;
